// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"383":"module-cookieBanner","420":"module-offcanvas-helper","710":"module-offcanvas-nav","994":"module-tabMenu"}[chunkId] + "." + {"383":"14f3aff26598472981b0","420":"1580e94ea1ab2d51cf96","710":"d03225e74bc55e49675f","994":"635a369a27df0a3e7c77"}[chunkId] + ".js";
};